import { useNavigate } from "react-router-dom";
import "../../assets/css/profilePage.css";
import { useAuth } from "../../components/auth/AuthRequiredRoute/AuthRequiredRoute";
import HeaderComponent from "../Header/HeaderComponent";
import BottomBar from "../../components/ui/BottomBar/BottomBar";
import { formatThaiDate } from "../../utils/util";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useTranslation } from "react-i18next";
import HeaderTitle from "../../components/ui/HeaderTitle/HeaderTitle";
import { SquarePen } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { RequestCustomer } from "../../services/modules/verify";
import { RequestedBox } from "./_components/RequestedBox";

const ProfilePage = () => {
  const { userData, invalidateUser } = useAuth();
  const { t } = useTranslation("profile");

  const { data: requestCustomerData } = useQuery({
    queryKey: ["requestCustomer", userData?.id_card, userData?.date_of_birth],
    queryFn: () =>
      RequestCustomer({
        body: {
          id_card: userData?.id_card,
          date_of_birth: userData?.date_of_birth,
        },
      }),
    enabled: !!userData?.id_card && !!userData?.date_of_birth,
  });

  const isForeigner = userData?.is_foreigner ?? false;

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("idCard");
    localStorage.removeItem("dob");
    invalidateUser();
    window.location.assign("/");
  };

  const handleHome = () => {
    navigate("/");
  };

  const handleEdit = () => {
    navigate("/profile/edit");
  };

  const isDesktop = useIsDesktop();

  const isRequestCustomerPending = requestCustomerData?.resultData?.length > 0;

  return (
    <div id="PageProfile">
      <HeaderComponent title="" showIcon={true} />
      <HeaderTitle title={t("myProfile")} />
      <div className="wrapContent">
        <div className="bProfile">
          <div className="bInfo h-full">
            {isRequestCustomerPending && <RequestedBox />}
            <div className="bTop">
              <h3 className="tText">{t("detail")}</h3>
              <button onClick={handleEdit} disabled={isRequestCustomerPending}>
                {t("edit")} <SquarePen size={20} />
              </button>
            </div>
            <div className="bMiddle">
              <div className="bInside">
                <p className="tLeft">{t("prefix")}</p>
                <p className="tRight">{userData?.title}</p>
              </div>
              {isForeigner ? (
                <div className="bInside">
                  <p className="tLeft">{t("nameEng")}</p>
                  <p className="tRight">
                    {userData.first_name_en} {userData.middle_name_en || ""}{" "}
                    {userData.last_name_en}
                  </p>
                </div>
              ) : (
                <>
                  <div className="bInside">
                    <p className="tLeft">{t("nameTH")}</p>
                    <p className="tRight">
                      {userData?.first_name_th} {userData?.middle_name_th || ""}{" "}
                      {userData?.last_name_th}
                    </p>
                  </div>
                  <div className="bInside">
                    <p className="tLeft">{t("nameEng")}</p>
                    <p className="tRight">
                      {userData.first_name_en} {userData.middle_name_en || ""}{" "}
                      {userData.last_name_en}
                    </p>
                  </div>
                </>
              )}
              <div className="bInside">
                <p className="tLeft">{t("telephoneNumber")}</p>
                <p className="tRight">{userData.phone}</p>
              </div>
              <div className="bInside">
                <p className="tLeft">{t("email")}</p>
                <p className="tRight">{userData.email}</p>
              </div>
              <div className="bInside">
                <p className="tLeft">{t("place")}</p>
                <p className="text-right font-bold w-3/4">
                  {userData.address} {userData.sub_district} {userData.district}{" "}
                  {userData.province} {userData.zip}
                </p>
              </div>
            </div>
            <div className="bLogout mt-auto">
              {!isDesktop && (
                <button onClick={handleHome} className="btnHome">
                  {t("backToMain")}
                </button>
              )}

              <button onClick={handleLogout} className="btnLogout">
                {t("logOut")}
              </button>
            </div>
          </div>
        </div>
      </div>
      {!isDesktop && (
        <div className="mobile-menu-wrapper">
          <BottomBar />
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
